import { Page, Text, View, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  


page: {
  paddingTop: 70,  // ✅ enough space for header + student info
  paddingBottom: 40,
  paddingHorizontal: 15,
  fontSize: 10,
},


  headerContainer: {
    position: "absolute",
    top: 3,
    left: 4,
    right: 40,
    height: 50,
    justifyContent: "center",
  },

  logo: {
    position: "absolute",
    left: 0,                  // ✅ logo on left
    width: 120,
    height: 30,
  },

  header: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",      // ✅ text centered across page
  },

 

footer: {
  position: "absolute",
 bottom: 20,
  left: 40,
  right: 40,
  flexDirection: "row",
  justifyContent: "space-between", // ✅ left & right alignment
  fontSize: 5,
},


  // row: {
  //   flexDirection: "row",
  //   borderBottomWidth: 1,
  //   paddingVertical: 6,
  //   alignItems: "flex-start", // critical
  // },

  // cell: {
  //   flex: 1,
  //   paddingRight: 8,
  // },
  
  
dateGroup: {
    borderBottomWidth: 1,
    borderColor: "#000",
    paddingVertical: 4,
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start", // 🔑 important
  },
   row1: {
    flexDirection: "row",
    alignItems: "flex-start", // 🔑 important
     borderBottomWidth: 1,
    borderColor: "#000",
    paddingVertical: 4,
  },
  cell: {
    
    fontSize: 9,
  },
  bold: {
    fontWeight: "bold",
    marginBottom: 2,
  },

  
studentInfo: {
  marginTop: 2,
  marginBottom: 10,
  flexDirection: "row",
  justifyContent: "space-between",
},

studentText: {
  fontSize: 10,
},

tableHeader: {
  height:30,
  backgroundColor: "#441968",   
  alignItems: "center",    // black background
},

headerCell: {
  
  paddingRight: 8,
  color: "#efebeb",               // white text
  fontWeight: "bold",
  extAlign: "center", 
},



colDate: {
  flex: 1,
  textAlign: "center",
  
},

colTime: {
  flex: 0.9,
  textAlign: "center",
},
colDate1: {
  flex: 0.7,
  textAlign: "left",

},

colTime1: {
  flex: 0.9,
  textAlign: "left",
  
},
colDuration: {
  flex: 0.6,
  textAlign: "center",
},

colModule: {
  flex: 1.5,
},
colStatus: {
 
  flex: 1.2,
},
colStatus1: {
  paddingLeft:8,
  flex: 1.2,
},

  hoursCol: {
    width: "20%",
    textAlign: "center",
  },
  modeCol: {
    width: "20%",
    textAlign: "center",
  },
  courseCol: {
    width: "60%",
    textAlign: "center",
  },
  hoursCol1: {
    width: "20%",
    
  },
  modeCol1: {
    width: "20%",
    
  },
  courseCol1: {
    width: "60%",
  
  },

});
export default styles;